import React from "react";
import {Trans, useTranslation} from "react-i18next";
import window from "../../lib/WindowExtended";
import {useProductListContext} from "../productListProvider/ProductListProvider";

const SearchHeadline: React.FC = () => {
  const {state} = useProductListContext();
  const {t} = useTranslation();

  const queryParam = new URLSearchParams(window.location.search).get("q");
  if (!queryParam) {
    return null;
  }

  return (
    <div className="column-8 column-l-12">
      <h1 className="h2 regular mb-4">
        {state.loading ? (
          t("general.loading")
        ) : (
          <Trans
            i18nKey="search.searchHits--query--total"
            ns="translations"
            components={{
              s: <strong className="bold" />,
            }}
            values={{
              query: queryParam,
              total: state.total,
            }}
          />
        )}
      </h1>
    </div>
  );
};

export default SearchHeadline;
